import _ from 'lodash'
import cookie from 'js-cookie'

export default {
    set (key, value, options = {}) {
        return cookie.set(`rentora:${key}`, value, options)
    },

    get (key) {
        return cookie.get(`rentora:${key}`)
    },

    has (key) {
        return !_.isUndefined(cookie.get(`rentora:${key}`))
    },

    remove (key) {
        cookie.remove(`rentora:${key}`)
    }
}
